var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterpriseKnowledgeBaseForAiAgentsAMethodology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1376 768",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Seven-step methodology for an enterprise knowledge base that survives production",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1376,
    height: 768,
    fill: "#111827"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Outfit, Poppins, 'Segoe UI', Helvetica, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 110,
    fontSize: 15,
    fontWeight: 600,
    fill: "#7CC4FF",
    textAnchor: "start",
    letterSpacing: 2.4,
    opacity: 1
  }, "ENTERPRISE KNOWLEDGE BASE FOR AI AGENTS"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 164,
    fontSize: 40,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Seven steps, in this order"), /*#__PURE__*/React.createElement("path", {
    d: "M190 330 L1030 330 Q1090 330 1090 390 L1090 480 Q1090 540 1030 540 L470 540",
    fill: "none",
    stroke: "#2B3A55",
    strokeWidth: 6,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 330,
    r: 34,
    fill: "#111827",
    stroke: "#3E6FB0",
    strokeWidth: 4,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 338,
    fontSize: 22,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 272,
    fontSize: 17,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Inventory &amp; triage"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 294,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "what goes in, what stays out"), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 330,
    r: 34,
    fill: "#111827",
    stroke: "#3E6FB0",
    strokeWidth: 4,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 338,
    fontSize: 22,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 272,
    fontSize: 17,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Chunk by structure"), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 294,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "sections, clauses, rows"), /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 330,
    r: 34,
    fill: "#111827",
    stroke: "#3E6FB0",
    strokeWidth: 4,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 338,
    fontSize: 22,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 272,
    fontSize: 17,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Embed + re-rank"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 294,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "hybrid keyword + vector"), /*#__PURE__*/React.createElement("circle", {
    cx: 1030,
    cy: 330,
    r: 34,
    fill: "#111827",
    stroke: "#7CC4FF",
    strokeWidth: 4,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 338,
    fontSize: 22,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 272,
    fontSize: 17,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Evaluate retrieval"), /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 294,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "before generation, always"), /*#__PURE__*/React.createElement("circle", {
    cx: 1030,
    cy: 540,
    r: 34,
    fill: "#111827",
    stroke: "#3E6FB0",
    strokeWidth: 4,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 548,
    fontSize: 22,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "5"), /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 610,
    fontSize: 17,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Access control"), /*#__PURE__*/React.createElement("text", {
    x: 1030,
    y: 632,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "enforced at query time"), /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 540,
    r: 34,
    fill: "#111827",
    stroke: "#3E6FB0",
    strokeWidth: 4,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 548,
    fontSize: 22,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "6"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 610,
    fontSize: 17,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Sync &amp; ownership"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 632,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "indexed when, by whom"), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 540,
    r: 34,
    fill: "#111827",
    stroke: "#3E6FB0",
    strokeWidth: 4,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 548,
    fontSize: 22,
    fontWeight: 800,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "7"), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 610,
    fontSize: 17,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Observe"), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 632,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "every retrieval logged"), /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 410,
    width: 300,
    height: 56,
    rx: 10,
    fill: "#1A2A4A",
    stroke: "#7CC4FF",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 433,
    fontSize: 14,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Most projects skip step 4."), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 452,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "That is why the demo dies in month three."), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 700,
    fontSize: 16,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 3,
    opacity: 1
  }, "WORKFLOX"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseKnowledgeBaseForAiAgentsAMethodology);
export default __webpack_public_path__ + "static/media/enterprise-knowledge-base-for-ai-agents-a-methodology.27cff541c110ef7259430e91df22a574.svg";
export { ForwardRef as ReactComponent };